import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener las propiedades de contactos en hubspot.
 *
 * @return {Promise<Array>} Lista de propiedades de contactos.
 */
export async function fetchContactPropertiesHubspot() {
  const url = "/hubspot/properties/contacts/";
  const response = await httpManager.get(url);
  console.log(response, 'response fetchContactPropertiesHubspot');
  return response?.data;
}